"use client";

import { DatePicker } from "@/components/ui/datepicker";
import { Input, Button, Checkbox } from "rizzui";
import { PiTrashDuotone } from "react-icons/pi";

type FilterElementProps = {
  isFiltered: boolean;
  filters: { [key: string]: any };
  updateFilter: (columnId: string, filterValue?: string | any[]) => void;
  handleReset: () => void;
};

export default function FilterElement({
  isFiltered,
  handleReset,
  filters,
  updateFilter,
}: FilterElementProps) {
  return (
    <div className="flex md:flex-row items-end justify-between flex-col w-full flex-wrap gap-4">
      <div className="flex md:flex-row flex-col w-full md:w-fit items-end flex-wrap gap-2">
        <DatePicker
          selected={filters?.["startDate"]}
          onChange={([startDate, endDate]: any) => {
            updateFilter("startDate", startDate || undefined);
            updateFilter("endDate", endDate || undefined);
          }}
          selectsRange
          startDate={filters?.["startDate"]}
          endDate={filters?.["endDate"]}
          dateFormat="dd MMM, yyyy"
          placeholderText="Select date range"
          popperPlacement="bottom-end"
          inputProps={{
            variant: "text",
            inputClassName: "p-0 px-1 h-10 [&_input]:text-ellipsis",
            size: "sm",
          }}
          className="rounded border [&_.rizzui-input-container]:px-3 [&_.rizzui-input-container]:py-1.5 w-full md:w-[280px] h-10"
        />
        <Input
          type="text"
          placeholder="Search by domain..."
          value={filters?.["domain"] ?? ""}
          onChange={(e) => updateFilter("domain", e.target.value)}
          className="w-full md:w-[200px] h-10 [&_span]:h-10"
          size="sm"
        />
        <Input
          type="text"
          placeholder="Search by IP..."
          value={filters?.["ip"] ?? ""}
          onChange={(e) => updateFilter("ip", e.target.value)}
          className="w-full md:w-[180px] [&_span]:h-10"
          size="sm"
        />
        <Input
          type="text"
          placeholder="Search by project..."
          value={filters?.["projectName"] ?? ""}
          onChange={(e) => updateFilter("projectName", e.target.value)}
          className="w-full md:w-[200px] [&_span]:h-10"
          size="sm"
        />
        <div className="flex items-center gap-2 h-[30px]">
          <Checkbox
            name="isSpam"
            label="Spam only"
            checked={filters?.["isSpam"] === "true"}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              updateFilter("isSpam", e.target.checked ? "true" : undefined)
            }
            className="text-sm"
          />
        </div>
        {isFiltered && (
          <Button
            className="max-md:w-full"
            size="sm"
            onClick={handleReset}
            variant="flat"
          >
            <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" /> Clear
          </Button>
        )}
      </div>
    </div>
  );
}
